let host = "";
let host2 = "";
if (window.location.hostname == "localhost") {
  host = "wss://ws.kooex.info";
  host2 = "wss://futuresws.kooex.info";
} else {
  // 协议转换 http→ws, https→wss（保留原始逻辑）
  const wsProtocol = window.location.protocol.replace("http", "ws");
  // 确保 WS 子域名为 ws.xxx：无 www 的域名也补上 ws. 前缀
  const wsHostname = window.location.hostname.replace(/^www\./, "ws.");
  const ensuredWsHostname = wsHostname.startsWith("ws.")
    ? wsHostname
    : "ws." + wsHostname;

  host = wsProtocol + "//" + ensuredWsHostname;
  // host2: 沿用 futuresws 前缀替换 ws 前缀
  host2 = wsProtocol + "//" + ensuredWsHostname.replace(/^ws\./, "futuresws.");
}

const prefixPath = (path) => {
  let prefix = "";
  if (window.location.hostname == "www.kooxapp.com") {
    if (/fe\-ex\-api/.test(path)) {
      prefix = "https://webapi.kooxappapi.lol";
    }
    if (/fe\-co\-api/.test(path)) {
      prefix = "https://futuresapi.kooxappapi.lol";
    }
    if (/fe\-otc\-api/.test(path)) {
      prefix = "https://otcapi.kooxappapi.lol";
    }
    if (/fe\-quant\-api/.test(path)) {
      prefix = "https://quantapi.kooxappapi.lol";
    }
    if (/fe\-debit\-api/.test(path)) {
      prefix = "https://debitapi.kooxappapi.lol";
    }
  }
  return prefix + path;
};

export default {
  qws: host + "/kline-api/ws",
  qws_futures: host2 + "/kline-api/ws",
  logout: prefixPath("/fe-ex-api/user/login_out"),
  userinfo: prefixPath("/fe-ex-api/common/user_info"),
  appdownload: prefixPath("/fe-ex-api/common/app_download"),
  message_noread: prefixPath("/fe-ex-api/message/v4/get_no_read_message_count"),
  locale: prefixPath("/fe-ex-api/common/get_locale"), // 语言包
  index: prefixPath("/fe-ex-api/common/index"),
  index_v5: prefixPath("/fe-ex-api/common/index_v5"),
  public_info: prefixPath("/fe-co-api/common/public_info"), // 合约信息
  ip_limit: prefixPath("/fe-ex-api/limit_ip_login"), // ip限制
  public_info_v4: prefixPath("/fe-ex-api/common/public_info_v4"), // 基础信息
  getStatsRate: prefixPath("/fe-ex-api/common/getStatsRate"), // 汇率信息
  language_footer_list: prefixPath("/egw/public/spot/common/public_resource"), // 语言包

  // 首页改版
  FOLLOW_STATISTICS: prefixPath("/egw/public/futures/follow/statistics"),
  FOLLOW_TRADERS: prefixPath("/egw/public/futures/follow/traders"),
  RANKIN_AND_RECOMMEND: prefixPath(
    "/egw/public/spot/home_page/symbol_coin_ranking_and_recommend"
  ),
  HOME_PAGE_DATA: prefixPath("/egw/public/spot/common/home_page_data"),
  MARKET_RANK: prefixPath("/egw/public/futures/symbol/market_rank"),
  HOUR_KLINE: prefixPath("/egw/public/futures/common/hour_kline"),
};
